import { UseFileUploadParams, useFileUpload } from "@/hooks/use-file-upload.hook.tsx";
import { Button, ButtonIcon, FontAwesomeIcon } from "@skailer-com/uikit";

export interface FileUploadProps extends UseFileUploadParams {
  buttonText?: string;
}

export const FileUpload = ({ buttonText, ...params }: FileUploadProps) => {
  const { input, openPicker, isLoading } = useFileUpload(params);

  return (
    <>
      {input}

      {buttonText ? (
        <Button
          variant={"secondary"}
          className={"w-full"}
          onClick={openPicker}
          leftIcon={<FontAwesomeIcon icon={"fa-light fa-paperclip text-lg"} />}
          isLoading={isLoading}
        >
          {buttonText}
        </Button>
      ) : (
        <ButtonIcon
          variant={"secondary"}
          onClick={openPicker}
          icon={
            isLoading ? (
              <FontAwesomeIcon icon="fa-light fa-spinner fa-spin" />
            ) : (
              <FontAwesomeIcon icon={"fa-light fa-paperclip text-lg"} />
            )
          }
        />
      )}
    </>
  );
};
